import React, { useState } from "react";
import { Typography } from "antd";
import { MasterConfigs } from "../../../interfaces/entity";
import './index.scss';
import MasterComponent from "../../../components/Forms";
const { Title } = Typography

const LeaveTypes = () => {
    const config: MasterConfigs = {
        title: 'Leave Types',
        modalTitle: () => 'Leave Type',
        api: () => '/leave-type',
        getFormColumns: () => [
            {
                label: 'Select Leave Type',
                name: 'leaveCategory',
                type: 'select',
                isCombo: true,
                rules: [{ required: true, message: 'Please select leave type' }]
            },
            {
                span: 16,
            },
            {
                label: 'Leave name',
                name: 'leaveName',
                type: 'text',
                rules: [{ required: true, message: 'Please enter leave name' }]
            },
            {
                label: 'Short code',
                name: 'shortCode',
                type: 'text',
                rules: [{ required: true, message: 'Please enter short code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 12
            },
            {
                label: 'Classify as Sick or Medical Leave',
                name: 'clasifyasSickOrMedical',
                type: 'checkbox',
                span: 24,
            },
            {
                formItem: () => <Title level={5}>Additional Options (Optional)</Title>,
                span: 24
            },
            {
                label: 'This leave applicable for',
                name: 'leaveApplicableFor',
                type: 'radio',
                span: 24,
                children: [
                    {
                        name: 'Male',
                        value: 'male',
                    }, {
                        name: 'Female',
                        value: 'female',
                    },
                    {
                        name: 'Both',
                        value: 'both',
                    }
                ]
            },
            {
                label: 'Restrict employees having martial status',
                name: 'restrictEmployeeshavingMartialStatus',
                type: 'radio',
                span: 24,
                children: [
                    {
                        name: 'Yes',
                        value: 'yes',
                    }, {
                        name: 'No',
                        value: 'no',
                    }
                ]
            }
        ],
        getColumns: () => [
            {
                title: 'Leave Name',
                dataIndex: 'leaveName',
                key: 'leaveName',
            },
            {
                title: 'Short Code',
                dataIndex: 'shortCode',
                key: 'shortCode',
            },
            {
                title: 'Leave Category',
                dataIndex: 'leaveCategory',
                key: 'leaveCategory',
                render: (e) => e?.name
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                ellipsis: true,
                width: '50%'
            }
        ],
        combo: [
            {
                name: 'leaveCategory',
                api: '/leave-category',
                idKey: '_id',
                render: (e) => e.name
            }
        ],
        actions: [{ actionType: 'Add', name: 'Add Leave Type' }]
    }

    return <MasterComponent config={config} isModal={true} />
};

export default LeaveTypes;